import { render, staticRenderFns } from "./FinancialSummaryRow.vue?vue&type=template&id=b37fb96a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./FinancialSummaryRow.vue?vue&type=script&lang=js&"
export * from "./FinancialSummaryRow.vue?vue&type=script&lang=js&"
import style0 from "./FinancialSummaryRow.vue?vue&type=style&index=0&id=b37fb96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37fb96a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VIcon,VLayout,VTooltip})
